import { render, staticRenderFns } from "./HistogramSlider.vue?vue&type=template&id=b253fc20"
import script from "./HistogramSlider.vue?vue&type=script&lang=js"
export * from "./HistogramSlider.vue?vue&type=script&lang=js"
import style0 from "./HistogramSlider.vue?vue&type=style&index=0&id=b253fc20&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports